import { Tab, Box, Tabs, useTheme } from '@mui/material'
import React, { useState } from 'react'
import PrivateRC from '../../components/PrivateRC'
import Emprestimo from './emprestimos'
import HistoricoEmprestimos from './historicoEmprestimos'
const DashboardMultiplo = () => {
  const [tab, setTab] = useState(0)
  const theme = useTheme()
  return (
    <Box sx={{ mt: 2 }}>
      <PrivateRC roles="bibliotecario">
        <Tabs
          value={tab}
          onChange={(event, newValue) => {
            setTab(newValue)
          }}
          TabIndicatorProps={{
            style: {
              backgroundColor: theme.palette.leitura.main
            }
          }}
        >
          <Tab onClick={() => setTab(0)} label="emprestimos" />
          <Tab onClick={() => setTab(1)} label="histórico" />
        </Tabs>
      </PrivateRC>
      {tab === 0 && (
        <PrivateRC roles="leitor">
          <Emprestimo />
        </PrivateRC>
      )}
      {tab === 1 && (
        <PrivateRC roles="bibliotecario">
          <HistoricoEmprestimos />
        </PrivateRC>
      )}
    </Box>
  )
}

export default DashboardMultiplo
